import api from './api'

/* --- GET --- */
const fetchUser = () => {
  return api.get('/user')
}

/* --- POST --- */
const login = ({ login, password }) => {
  return api.post('/user/login?isAdmin=true', { login, password })
}

/* --- POST --- */
const forgotPassword = ({ email }) => {
  return api.post('/user/admin/password-recovery/send', { email })
}

/* --- POST --- */
async function verifyResetPasswordToken({ token }) {
  return await api.post('/user/password-recovery/check', { token })
}

async function resetPassword({ token, password }) {
  return await api.post('/user/password-recovery/update-password', { token, password })
}

export {
  fetchUser,
  login,
  forgotPassword,
  verifyResetPasswordToken,
  resetPassword
}
